'use client';

import type { ReactNode } from 'react';
import type { EditContentProps } from '../../tool-config-types';
import type { AttackerToolInput } from './types';
import { AttackerEditModal } from './attacker-edit-modal';
import { attackerHitlConfig } from './hitl-config';

function parseAttackerData(data: unknown): AttackerToolInput {
  if (!data || typeof data !== 'object') {
    return { signalId: '', userAttackPrompt: '' };
  }

  const input = data as Record<string, unknown>;

  return {
    signalId: String(input.signalId || ''),
    endpointId: input.endpointId ? String(input.endpointId) : undefined,
    harEntryId: input.harEntryId ? String(input.harEntryId) : undefined,
    credentialId: input.credentialId ? String(input.credentialId) : undefined,
    userNotes: input.userNotes ? String(input.userNotes) : undefined,
    userAttackPrompt: String(input.userAttackPrompt || ''),
  };
}

function AttackerEditContentWrapper({
  onClose,
  onSubmit,
  toolName,
  extractedData = [],
}: EditContentProps) {
  const handleSubmit = (editedData: AttackerToolInput) => {
    const wrappedData = attackerHitlConfig.wrapEditedData([editedData]);
    onSubmit(wrappedData);
  };

  if (extractedData.length === 0) return null;

  const attackerData = parseAttackerData(extractedData[0]);

  return (
    <AttackerEditModal
      isOpen
      onClose={onClose}
      onSubmit={handleSubmit}
      data={attackerData}
      actionName={toolName}
      renderMode="inline"
    />
  );
}

export const renderAttackerEditContent = (
  props: EditContentProps,
): ReactNode => <AttackerEditContentWrapper {...props} />;
